import React, { useEffect, useState } from 'react';
import JiraIssueService from '../../Services/JiraIssueService';
import DevelopmentNewsDetail from './DevelopmentNewsDetail';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import { statusPillClass } from './homeHelpers';
import FigmaBadge from '../../Elements/FigmaBadge';

const STAT_CARDS = [
  { key: 'planned', label: 'Planned', cls: 'c-violet', sub: 'in the backlog' },
  { key: 'inProgress', label: 'In Progress', cls: 'c-sky', sub: 'actively building' },
  { key: 'testing', label: 'Testing', cls: 'c-gold', sub: 'in QA / UAT' },
  { key: 'releasedYTD', label: 'Released YTD', cls: 'c-dgreen', sub: 'shipped this year' },
];

function DevStatus({ statusName }) {
  return (
    <FigmaBadge
      variant={statusPillClass(statusName)}
      label={statusName}
    />
  );
}

function DevelopmentNews() {
  const [planned, setPlanned] = useState([]);
  const [released, setReleased] = useState([]);
  const [stats, setStats] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    JiraIssueService.GetStats()
      .then((s) => {
        setStats(s || null);
        setLastUpdated(s && s.statDate ? new Date(s.statDate) : new Date());
      })
      .catch(() => setStats(null));
    JiraIssueService.GetPlannedIssues()
      .then((r) => setPlanned(JiraIssueService.ConvertDBItems(r && r.data ? r.data : [])))
      .catch(() => setPlanned([]));
    JiraIssueService.GetReleasedIssues()
      .then((r) => setReleased(JiraIssueService.ConvertDBItems(r && r.data ? r.data : [])))
      .catch(() => setReleased([]));
  }, []);

  return (
    <>
      <div>
        <div
          className='home-sec-head'
          style={{ marginBottom: 14 }}
        >
          <span className='sh-ic'>
            <i className='fa-solid fa-code-branch' />
          </span>
          <div className='sh-txt'>
            <span className='eyebrow'>Pipeline</span>
            <h2>Development news</h2>
          </div>
          <div className='sp' />
          {lastUpdated ? (
            <span className='sh-meta'>
              Last updated <b>{dateTimeHelper.toYYYYsMMsDD(lastUpdated)}</b>
            </span>
          ) : null}
        </div>
        <div className='stat-grid'>
          {STAT_CARDS.map((s) => (
            <div
              className={'stat-card ' + s.cls}
              key={s.key}
            >
              <div className='st-top'>
                <span className='st-dot' />
                <span className='st-label'>{s.label}</span>
              </div>
              <span className='st-num'>{stats && stats[s.key] != null ? stats[s.key] : 0}</span>
              <span className='st-sub'>{s.sub}</span>
            </div>
          ))}
        </div>
      </div>

      <div className='home-card coming'>
        <div className='card-head'>
          <span className='ch-ic'>
            <i className='fa-solid fa-list-check' />
          </span>
          <h3>Top business features coming</h3>
          <span className='ch-count'>{planned.length} planned &amp; in progress</span>
        </div>
        <table className='home-tbl t-coming'>
          <thead>
            <tr>
              <th>Title</th>
              <th className='col-owner'>Business owner</th>
              <th>Status</th>
              <th className='col-type'>Development type</th>
              <th className='col-rel'>Planned release</th>
            </tr>
          </thead>
          <tbody>
            {planned.length ? (
              planned.map((r) => (
                <tr key={r.JiraIssueId}>
                  <td>
                    <span
                      className='home-link'
                      role='button'
                      tabIndex={0}
                      onClick={() => setSelected(r)}
                    >
                      {r.BravoTitle}
                    </span>
                  </td>
                  <td className='col-owner'>{r.BusinessOwner || '—'}</td>
                  <td>
                    <DevStatus statusName={r.StatusName} />
                  </td>
                  <td className='col-type'>
                    <span className='dev-type'>{r.DevelopmentType || '—'}</span>
                  </td>
                  <td className='col-rel'>
                    {r.TargetDate ? (
                      <span className='rel-date'>{dateTimeHelper.toYYYYsMM(r.TargetDate)}</span>
                    ) : (
                      <span className='rel-none'>—</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className='home-tbl-empty'
                  colSpan={5}
                >
                  No items to display.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className='home-card released'>
        <div className='card-head'>
          <span className='ch-ic'>
            <i className='fa-solid fa-circle-check' />
          </span>
          <h3>What&apos;s new</h3>
          <span className='ch-count'>{released.length} recently released</span>
        </div>
        <table className='home-tbl'>
          <thead>
            <tr>
              <th>Title</th>
              <th className='col-owner'>Business owner</th>
              <th className='col-rel'>Released</th>
            </tr>
          </thead>
          <tbody>
            {released.length ? (
              released.map((r) => (
                <tr key={r.JiraIssueId}>
                  <td>
                    <span
                      className='home-link'
                      role='button'
                      tabIndex={0}
                      onClick={() => setSelected(r)}
                    >
                      {r.BravoTitle}
                    </span>
                  </td>
                  <td className='col-owner'>{r.BusinessOwner || '—'}</td>
                  <td className='col-rel'>
                    <span className='rel-date'>
                      {r.StatusCategoryChangeDate ? dateTimeHelper.toYYYYsMMsDD(r.StatusCategoryChangeDate) : '—'}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className='home-tbl-empty'
                  colSpan={3}
                >
                  No items to display.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {selected ? (
        <DevelopmentNewsDetail
          item={selected}
          onClose={() => setSelected(null)}
        />
      ) : null}
    </>
  );
}

export default DevelopmentNews;
